import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { PagesComponent } from "./pages/pages.component";
import { LoginComponent } from "./login/login.component";
import { UserComponent } from "./pages/user/user.component";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { TranslocoRootModule } from "./transloco-root.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RecoveryPasswordComponent } from "./recovery-password/recovery-password.component";
import { BookingComponent } from "./pages/booking/booking.component";
import { RegistrationComponent } from "./registration/registration.component";
import { PlansRegistrationComponent } from "./pages/plans-registration/plans-registration.component";
import { CompleteProfileComponent } from "./pages/complete-profile/complete-profile.component";
import { ComponentsModule, FormModule } from "@stdoutsrl/design-kit";
import { ChangePasswordComponent } from "./change-password/change-password.component";
import { UsersForceResetPasswordComponent } from "./tables-custom-actions/users-force-reset-password.component";
import { ProductAssociationComponent } from "./tables-custom-actions/product-association.component";
import { CompanyProductSuggestionComponent } from "./tables-custom-actions/company-product-suggestion.component";
import { PaymentComponent } from "./payment/payment.component";
import { PaymentErrorComponent } from "./payment-error/payment-error.component";
import { CreateCompanyComponent } from "./tables-custom-actions/create-company.component";
import { DownloadSalesExcelComponent } from "./tables-custom-actions/download-sales-excel.component";
import { ReminderComponent } from "./pages/reminder/reminder.component";
import { UserDashboardComponent } from "./pages/user-dashboard/user-dashboard.component";
import { CashRegisterComponent } from "./pages/cash-register/cash-register.component";
import { OperatorShiftsComponent } from "./pages/operator-shifts/operator-shifts.component";
import { CreateOperatorComponent } from "./tables-custom-actions/create-operator.component";
import { EditOperatorComponent } from "./tables-custom-actions/edit-operator.component";
import { CompanyProductSuggestionCompleteProfileComponent } from "./tables-custom-actions/company-product-suggestion-complete-profile.component";
import { ReservePublicComponent } from "./reserve-public/reserve-public.component";
import { DetailOperatorComponent } from "./tables-custom-actions/detail-operator.component";
@NgModule({
  declarations: [
    AppComponent,
    PagesComponent,
    LoginComponent,
    PaymentComponent,
    UserComponent,
    RecoveryPasswordComponent,
    BookingComponent,
    RegistrationComponent,
    PlansRegistrationComponent,
    CompleteProfileComponent,
    ChangePasswordComponent,
    UsersForceResetPasswordComponent,
    ProductAssociationComponent,
    CompanyProductSuggestionComponent,
    PaymentErrorComponent,
    CreateCompanyComponent,
    DownloadSalesExcelComponent,
    ReminderComponent,
    UserDashboardComponent,
    CashRegisterComponent,
    OperatorShiftsComponent,
    CreateOperatorComponent,
    EditOperatorComponent,
    CompanyProductSuggestionCompleteProfileComponent,
    ReservePublicComponent,
    DetailOperatorComponent
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    TranslocoRootModule,
    ComponentsModule,
    FormModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class AppModule {}
